<template>
  <div>
    <a-table size="small" style="border:0" :data-source="dataList" :pagination="false" :show-header="false">
      <a-table-column key="level" title="P级别" width="70px">
        <template slot-scope="record">
          <a-select v-model="record.level" placeholder="请选择P级别" @change="onChange">
            <a-select-option :value="5">P5</a-select-option>
            <a-select-option :value="6">P6</a-select-option>
            <a-select-option :value="7">P7</a-select-option>
          </a-select>
        </template>
      </a-table-column>
      <a-table-column key="value" title="成本" width="100px">
        <template slot-scope="record">
          <a-input-number v-model="record.value" style="width: 100%;" :max="24" :min="0" :precision="2" @change="onChange" />
        </template>
      </a-table-column>
      <a-table-column key="action" title="操作" width="70px">
        <template slot-scope="text,record,index">
          <a-space size="small">
            <a-button style="padding: 0 1px 0 6px" size="small" type="link" @click="add(index)">
              <a-icon type="plus" />
            </a-button>
            <a-button style="padding: 0 1px;color: red;" size="small" type="link" @click="del(index)">
              <a-icon type="delete" />
            </a-button>
          </a-space>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      dataList: [{ level: 6, value: 0 }]
    };
  },
  computed: {
    reviewUser() {
      return 'review的人';
    }
  },
  watch: {
    value(val = {}) {
      this.dataList = val || [{ level: 6, value: 0 }];
    }
  },

  mounted() {
  },
  methods: {
    add(index) {
      this.dataList.splice(index + 1, 0, { level: 6, value: 0 });
      this.onChange();
    },
    del(index) {
      this.dataList.splice(index, 1);
      this.onChange();
    },
    onChange() {
      console.log('onChange');
      this.triggerChange(this.dataList);
    },
    triggerChange(changedValue) {
      // Should provide an event to pass value to Form.
      this.$emit('change', Object.assign({}, this.$data, changedValue));
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-table-small{
  border:0
}

/deep/.ant-table-row-cell-break-word{
  border:0;
  padding:2px !important;
}

.ant-input-number{
  width: 100%;
}
</style>
